export default {
  SET_ONBOARDING_DETAILS: "SET_ONBOARDING_DETAILS",
  SET_ONBOARDING_FETCH_STATE: "SET_ONBOARDING_FETCH_STATE",
  APP_LOG_OUT: "APP_LOG_OUT",
};
